// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_5y-4";
export var collapsed = "_5y-1";
export var headerBar = "_5y-0";
export var leftHeaderContent = "_5y-3";
export var subjectContainer = "_5y-2";